import { render, staticRenderFns } from "./TeamPlanet.vue?vue&type=template&id=5f163b99"
import script from "./TeamPlanet.vue?vue&type=script&lang=js"
export * from "./TeamPlanet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports